import '../button';

describe('button', () => {
  it('Expect custom element <wc-button> is defined', () => {
    expect(customElements.get('wc-button')).toBeDefined();
  });
});
